<template>
    <div v-if="code && code === 'NO_EXT'">
        <div class="alert alert-warning">
            <h3>You Need The Who Deleted Me Browser Extension</h3>
            <p>To view this page you need to get the Who Deleted Me browser extension.</p>
            <p>
                <a href="/"
                   class="btn btn-info">
                    <i class="glyphicon glyphicon-cloud-download"></i>
                    Get The Extension
                </a>
            </p>
        </div>
    </div>
    <div v-else-if="code && code === 'NO_USER'">
        <div class="alert alert-warning">
            <h3>You Need To Sync Before You See This Page</h3>
            <p>
                Great, you have the Who Deleted Me browser extension!
                But it looks like we don't have any data for you yet.
                Before we can show you this page you need to sync your friends list with Who Deleted Me.
            </p>
            <p>Click the button below to sync your friends and continue:</p>
            <p>
                <a href="/sync"
                   class="btn btn-info">
                    <i class="glyphicon glyphicon-refresh"></i>
                    Sync Friends
                </a>
            </p>
        </div>
    </div>
    <div v-else
         class="alert alert-danger">
        <h3>There Was An Error Loading This Page</h3>
        <p>Please try again or contact us of this error keeps happening.</p>

        <p class="mt-05">
            Error details:
        </p>
        <pre>{{ error }}</pre>
    </div>
</template>

<script>
export default {
    props: {
        error: {
            type: String,
            required: true,
        },
        code: {
            type: String,
            default: null,
        },
    },
};
</script>
